import * as React from "react";
import { ColumnHelper } from "@tanstack/react-table";
import _ from "lodash";

import { Text } from "src/library/components/Text";
import {
  IList,
  IListLine
} from "src/core/lists/api/lists.api";
import { formatPrice } from "src/core/prices/utils";

/**
 * This function returns a reusable formated column definition for list total data to be used in Tanstack tables
 *
 * @param columnHelper
 * @returns column definition for list total data
 */
export const listTotalColumn = (
  columnHelper: ColumnHelper<IList>
) => {
  return columnHelper.accessor("listLines", {
    id: "value",
    header: "Total",
    cell: info => {
      const listLines: IListLine[] = info.getValue();

      if (listLines) {
        return (
          <Text>
            {formatPrice(_.sumBy(listLines, listLine => (listLine.totalPrice || 0) + (listLine.totalVatValue || 0)), 2, info.row.original.branch.priceCode?.currency)}
          </Text>
        );
      } else {
        return null;
      }
    },
    enableSorting: false,
    enableColumnFilter: false,
    minSize: 70,
    meta: { style: { align: "right" } }
  });
};
